import { LoadableActionFactory } from '../../../../shared/utils/redux/loadable/loadable.actions'
import { ProdEvent } from '../../models/prod-event.model'

export class JobsiteProdEventActions {
  public static getProdEvents = new LoadableActionFactory<void, ProdEvent[]>(
    '[JOBSITE PROD EVENT] GET ALL PROD EVENT',
  )
}
